import { instanceWithV2 as instance } from './SimpleAPIClient';
import CONFIG from '../config/config';

export interface CommissionContractOfferDto {
  id?: number;
  name: string;
  customerDescription?: string;
  saleDuration: number;
  salonSplitPercentage?: number;
  brideSplitPercentage?: number;
  dropFeePrice?: number;
  dropFeeCurrency?: string;
  renewalFeePrice?: number;
  renewalFeeCurrency?: string;
  displayOrder?: number;
  enabled?: boolean;
  metadata?: string;
}

const CommissionContractOffersAPI = {
  list: () =>
    instance(CONFIG.API_ENDPOINT).get<CommissionContractOfferDto[]>('v1/commission-contract-offers'),

  create: (dto: CommissionContractOfferDto) =>
    instance(CONFIG.API_ENDPOINT).post<CommissionContractOfferDto>('v1/commission-contract-offers', dto),

  update: (id: number, dto: CommissionContractOfferDto) =>
    instance(CONFIG.API_ENDPOINT).put<CommissionContractOfferDto>(`v1/commission-contract-offers/${id}`, dto),

  delete: (id: number) =>
    instance(CONFIG.API_ENDPOINT).delete(`v1/commission-contract-offers/${id}`),

  reorder: (orderedIds: number[]) =>
    instance(CONFIG.API_ENDPOINT).put('v1/commission-contract-offers/reorder', orderedIds),
};

export default CommissionContractOffersAPI;
